import {useEffect, useState} from 'react'
import {QueryStatus, QueryStatusType} from 'src/types'
import {OperacionLCLS} from "../types/types";
import {HttpLCLS} from "../api/httpLCLS";

type UseOperacionResult<TOperacion> = {
    status: QueryStatusType
    operacion: TOperacion | undefined
}

export const useOperacionLCLS: (idOperacion: number) => UseOperacionResult<OperacionLCLS> = (idOperacion: number) => {
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)
    const [operacion, setOperacion] = useState<OperacionLCLS>()

    useEffect(() => {
        setStatus(QueryStatus.Loading)

        HttpLCLS.get(idOperacion)
            .then(data => {
                setOperacion(data)
                setStatus(QueryStatus.Success)
            })
            .catch(() => setStatus(QueryStatus.Error))
    }, [idOperacion])

    return {status, operacion}
}
